import { useCachedFetch } from './useCachedFetch';

export const useHeaderFooterCache = () => {

  const { data: commonData, loading: commonLoading, error: commonError } = useCachedFetch('/data/locales/commonData.json');
  const { data: headerFooterData, loading: headerFooterLoading, error: headerFooterError } = useCachedFetch('/data/locales/headerFooter.json');
  const { data: articlesData, loading: articlesLoading, error: articlesError } = useCachedFetch('/data/locales/articles.json');

  const isLoading = commonLoading || headerFooterLoading || articlesLoading;
  const hasError = commonError || headerFooterError || articlesError;

  const getHeaderData = (currentLang) => {
    if (!commonData || !headerFooterData) return null;
    
    const translations = headerFooterData.translations?.[currentLang] || headerFooterData.translations?.en;
    if (!translations) return null;

    return {
      mainContent: {
        HeaderLogo: commonData.HeaderLogo,
        HeaderButton: translations.HeaderButton
      },
      generalContent: {
        SocialLinks: commonData.SocialLinks,
        Company: translations.Company,
        PhoneLink: commonData.PhoneLink
      },
      isValid: Boolean(
        commonData.HeaderLogo &&
        translations.HeaderButton?.text &&
        translations.HeaderButton?.link &&
        commonData.SocialLinks &&
        Object.keys(commonData.SocialLinks).length > 0 &&
        commonData.PhoneLink
      )
    };
  };

  const getFooterData = (currentLang) => {
    if (!commonData || !headerFooterData || !articlesData) return null;
    
    const translations = headerFooterData.translations?.[currentLang] || headerFooterData.translations?.en;
    if (!translations) return null;

    const loadedArticleData = articlesData.ArticleData || [];

    return {
      mainContent: {
        FooterArticle: translations.FooterArticle,
        MarketingTitle: translations.MarketingTitle,
        ServicesTitle: translations.ServicesTitle,
        InsightsTitle: translations.InsightsTitle,
        CompanyTitle: translations.CompanyTitle,
        MarketingServices: translations.MarketingServices,
        Services: translations.Services,
        FooterButton: translations.FooterButton,
        FooterSubtitle: translations.FooterSubtitle,
        Address: translations.Address,
        Copyright: translations.Copyright,
        PrivacyLink: translations.PrivacyLink,
        TermsLink: translations.TermsLink,
        SitemapLink: translations.SitemapLink,
        Impressum: translations.Impressum
      },
      generalContent: {
        SocialLinks: commonData.SocialLinks,
        Company: translations.Company,
        PhoneLink: commonData.PhoneLink,
        EmailLink: commonData.EmailLink
      },
      articleData: loadedArticleData,
      isValid: Boolean(
        translations.FooterArticle &&
        translations.MarketingTitle &&
        translations.ServicesTitle &&
        translations.InsightsTitle &&
        translations.CompanyTitle &&
        translations.MarketingServices &&
        Array.isArray(translations.MarketingServices) &&
        translations.Services &&
        Array.isArray(translations.Services) &&
        translations.FooterButton?.link &&
        translations.FooterButton?.text &&
        commonData.SocialLinks &&
        Object.keys(commonData.SocialLinks).length > 0
      )
    };
  };

  return {
    commonData,
    headerFooterData,
    articlesData,

    isLoading,
    hasError,

    getHeaderData,
    getFooterData,
    
    getTranslations: (currentLang) => {
      return headerFooterData?.translations?.[currentLang] || headerFooterData?.translations?.en;
    }
  };
};